'use client';

import { makeBaseProvider } from '@/contexts/make-base-provider';
import type { Domain, SiteId } from '@/features/basket/types/site';
import { createContext } from 'react';

interface Context {
  siteId: SiteId;
  domain: Domain;
}

export const DomainContext = createContext<Context>({
  siteId: 'wp_pl',
  domain: 'wyjatkowyprezent.pl',
});

export const DomainProvider = makeBaseProvider(DomainContext);
